import React from "react";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import VirtualInstrumentGauge from "./virtual-instrument-gauge";
// import VirtualInstrumentSlider from "./virtual-instrument-slider";
// import VirtualInstrument from "./virtual-instrument";

const LastValueQuery = loader("../graphql/LastValue.graphql");

interface Props {
  nodes?: any[];
  nodeId?: string;
  // startDate: number; // Date;
  // endDate: number; // Date;
  widgetStatic?: boolean;
  widgetTitle?: string;
}

const VirtualInstrumentContainer = (props: Props) => {
  // TODO support one or more nodes (if a panelId is given, then a table of all lastest values is shown)
  const {
    // nodes,
    nodeId,
    // startDate,
    // endDate,
    widgetStatic,
    widgetTitle,
  } = props;
  const { data, error, loading } = useQuery(LastValueQuery, {
    variables: { nodeId: nodeId },
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // const data = ({
  //   value: 23.4,
  //   unit: '°C',
  //   date: new Date(),
  // });
  return (
    <VirtualInstrumentGauge
      // nodes={nodes}
      data={data.lastValue}
      widgetStatic={widgetStatic}
      widgetTitle={widgetTitle}
    />
  );
};

export default VirtualInstrumentContainer;
